import { LazyLoadImage } from 'react-lazy-load-image-component';

export const avatar = (photo, gender) => {
  let photoUrl = null;
  if (photo) photoUrl = photo;
  else if (gender === 'Man') photoUrl = 'avatar-man-1.png';
  else if (gender === 'Woman') photoUrl = 'avatar-woman-1.png';
  else photoUrl = 'avatar-no-gender-1.png';

  return (
    <LazyLoadImage
      className="w-20 h-20"
      src={`https://filmconnx-production.s3.amazonaws.com/uploads/${photoUrl}`}
    />
  );
};

export const userSearchAvatar = (photo, gender) => {
  let photoUrl = null;
  if (photo) photoUrl = photo;
  else if (gender === 'Man') photoUrl = 'avatar-man-1.png';
  else if (gender === 'Woman') photoUrl = 'avatar-woman-1.png';
  else photoUrl = 'avatar-no-gender-1.png';

  return (
    <LazyLoadImage
      className="w-full h-full rounded-lg"
      src={`https://filmconnx-production.s3.amazonaws.com/uploads/${photoUrl}`}
    />
  );
};

export const navAvatar = (photo, gender, className) => {
  let photoUrl = null;
  if (photo) photoUrl = photo;
  else if (gender === 'Man') photoUrl = 'avatar-man-1.png';
  else if (gender === 'Woman') photoUrl = 'avatar-woman-1.png';
  else photoUrl = 'avatar-no-gender-1.png';

  return (
    <LazyLoadImage
      className={className}
      src={`https://filmconnx-production.s3.amazonaws.com/uploads/${photoUrl}`}
    />
  );
};
